function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
} 

/**
  * Attempts to hide the site banner that
  * Leadpages injects on certain pages.
  */
function hideLeadpagesBannerOnWhitelistedPages() {
  const bannerWhitelist = ['trade-services', 'wholesale', 'batch'];
  let urlParts = window.location.pathname.split('/');

  // Look at 3rd component, which is likely a Shopify page slug
  if (bannerWhitelist.includes(urlParts[2])) {
    let leadpagesBanner = document.getElementsByClassName('lp-bar__iframe-wrapper');
    let leadpagesBannerPlaceholder = document.getElementsByClassName('lp-bar__pusher');

    if (leadpagesBanner.length > 0 && leadpagesBannerPlaceholder.length > 0) {
      leadpagesBanner[0].style = 'height:0px;';
      leadpagesBannerPlaceholder[0].style = 'height:0px;';
      console.log('Removed banner from whitelisted page');

      return true;
    } else {
      // Leadpages JS hasn't run, return false, so caller can attempt again
      return false;
    }
  }

  return null;
}

document.addEventListener("DOMContentLoaded", async () => {
  const result = hideLeadpagesBannerOnWhitelistedPages();

  if (result === false) {
    await sleep(500);
    console.log('Attempting to remove banner after pause')
    hideLeadpagesBannerOnWhitelistedPages();
  }
})
